import { initAzureAuthentication } from '@vezeeta/azure-auth';
import authentication from 'configs/authentication';
import urls from 'configs/urls';

const { authConfig, redirectUrlCookieName } = authentication;

export const azureAuthentication = () =>
  initAzureAuthentication({
    authConfig,
    getAuthTokenApi: urls.masterServicesUrls.getApiAuthToken,
    applicationKey: process.env.REACT_APP_AZURE_AD_APP_APPLICATION_KEY,
    redirectUrlCookieName,
  });
